// 英文界面字典: key 为中文原文 (见 ./index.ts)。
// 按页面分块维护; 新迁移一个页面就在下面加一块, 未收录的文本会回落中文。
export const EN: Record<string, string> = {
  // ── 语言切换 ──
  '切换语言': 'Switch language',

  // ── 品牌 / 通用 ──
  '压裂智能平台': 'Frac Intelligence',
  '石油压裂智能平台': 'Petroleum Fracturing Intelligence Platform',
  '加载中...': 'Loading...',
  '加载中…': 'Loading…',
  '删除': 'Delete',
  '取消': 'Cancel',
  '用户': 'User',
  '未登录': 'Not signed in',
  '退出': 'Sign out',
  '退出登录': 'Sign out',
  '草稿': 'Draft',
  '进行中': 'Active',
  '已完成': 'Completed',
  '已归档': 'Archived',
  '水平井': 'Horizontal well',
  '定向井': 'Directional well',
  '直井': 'Vertical well',
  '{n} 人': '{n} members',

  // ── 侧边栏导航 ──
  '切换项目': 'Switch project',
  '导入数据': 'Import data',
  '仪表盘': 'Dashboard',
  '数据中心': 'Data Hub',
  '数据清单': 'Data inventory',
  '数据审核': 'Data review',
  '曲线视图': 'Curve viewer',
  '地质建模': 'Geological Modeling',
  '地层格架': 'Stratigraphic framework',
  '分层数据': 'Layer data',
  '2D 剖面': '2D section',
  '3D 模型': '3D model',
  '层位标记': 'Horizon markers',
  '天然裂缝': 'Natural fractures',
  '走向玫瑰图': 'Strike rose diagram',
  '密度剖面': 'Density profile',
  '裂缝参数': 'Fracture parameters',
  '构造解释': 'Structural interpretation',
  '层位与断层': 'Horizons & faults',
  '地质力学': 'Geomechanics',
  '参数计算工作台': 'Calculation workbench',
  '成果回读': 'Results',
  '参数剖面': 'Parameter profile',
  '地应力': 'In-situ stress',
  '岩石力学参数': 'Rock mechanics',
  '井壁稳定': 'Wellbore Stability',
  '安全泥浆窗口': 'Safe mud window',
  '坍塌破裂压力': 'Collapse & fracture pressure',
  '强度参数': 'Strength parameters',
  '甜点评价': 'Sweet Spot Evaluation',
  '压裂设计': 'Fracture Design',
  '新建方案': 'New design',
  '分段分簇': 'Staging & clusters',
  '完井与射孔': 'Completion & perforation',
  '材料设计': 'Materials',
  '泵注程序': 'Pump schedule',
  '方案总览': 'Design overview',
  '压裂模拟': 'Fracture Simulation',
  '三维总览': '3D overview',
  '动态曲线': 'Dynamic curves',
  '方案对比': 'Scenario comparison',
  '压中监测': 'Real-time Monitoring',
  '工况监测': 'Operation monitoring',
  '监测会话': 'Monitoring sessions',
  '实时分析': 'Live analysis',
  '事件流': 'Event stream',
  '规则配置': 'Rules',
  '自适应调控': 'Adaptive control',
  '策略演示': 'Policy demo',
  '指标验证': 'Metric validation',
  '训练过程': 'Training',
  '裂缝反演': 'Fracture Inversion',
  '缝网重构': 'Network reconstruction',
  '统计分析': 'Statistics',
  '产能预测': 'Production Forecast',
  '经济评价': 'Economic Evaluation',
  '成本构成': 'Cost breakdown',
  '产量预测': 'Production forecast',

  // ── 地质力学工作台模块 / 步骤 ──
  '数据总览': 'Data overview',
  '数据导入与预处理': 'Data import & preprocessing',
  '上覆岩层压力': 'Overburden pressure',
  '地层压力': 'Pore pressure',
  '地应力大小': 'Stress magnitude',
  '破裂压力': 'Fracture pressure',
  '坍塌压力': 'Collapse pressure',
  '综合评价与成果输出': 'Integrated evaluation & output',
  '区块地质力学数据': 'Block geomechanics data',
  '后处理与井筒综合可视化': 'Post-processing & wellbore view',
  '数据汇总全览': 'Data summary',
  '文件导入与解析': 'File import & parsing',
  '曲线道选择': 'Track selection',
  '标准列映射': 'Standard column mapping',
  '质量控制与补全': 'QC & gap filling',
  '统一深度表与输出': 'Unified depth table & output',
  '输入核对与参数': 'Input check & parameters',
  '计算输出与预览': 'Calculation & preview',
  '数据确认': 'Data confirmation',
  '计算': 'Calculation',
  '数据拼接/调整/提交': 'Splice / adjust / submit',
  '泥质含量计算': 'Shale volume',
  '地层划分': 'Zonation',
  '分层公式匹配与试算': 'Per-zone formula fitting',
  '实验标定': 'Lab calibration',
  '分层模型与参数': 'Zone model & parameters',
  '实测约束标定': 'Calibration to measurements',
  '结果确认/提交': 'Confirm / submit results',
  '破裂模型与分段': 'Fracture model & intervals',
  'LOT/FIT/漏失校核': 'LOT/FIT/loss check',
  '强度准则与分段': 'Failure criterion & intervals',
  '井壁事件校核': 'Wellbore event check',
  '窗口约束与阈值': 'Window constraints & thresholds',
  '风险分段复核': 'Risk interval review',
  '成果版本与提交': 'Result versions & submission',
  '审核井管理': 'Reviewed wells',
  '属性与层位样本': 'Properties & horizon samples',
  '网格建模与预览': 'Grid model & preview',
  '交叉验证与提交': 'Cross-validation & submission',

  // ── 未开通模块 / 占位页 ──
  '该模块尚未对当前账号开通': 'This module is not enabled for your account',
  '当前账号的可见范围由管理员配置。需要开通请联系平台管理员。':
    'Module visibility is configured by an administrator. Contact your platform administrator to enable it.',
  '回到仪表盘': 'Back to dashboard',
  '本子页待实装。数据模型已就绪,后续迭代填充界面。':
    'This page is not implemented yet. The data model is ready; the UI will follow in a later iteration.',
  'UCS / 内聚力 / 内摩擦角 / 抗拉强度 等井壁稳定计算输入。后续填实。':
    'Wellbore stability inputs such as UCS, cohesion, friction angle and tensile strength. Coming later.',

  // ── 登录 ──
  '用户名': 'Username',
  '密码': 'Password',
  '请输入用户名': 'Enter username',
  '请输入密码': 'Enter password',
  '登录中...': 'Signing in...',
  '登 录': 'Sign in',
  '账号由管理员统一开通': 'Accounts are provisioned by an administrator',
  '后端服务暂不可用，请确认后端已启动': 'Backend unavailable. Please make sure the backend is running.',
  '用户名或密码错误': 'Incorrect username or password',

  // ── 项目选择 / 新建项目 ──
  '选择项目': 'Select a project',
  '选择一个项目开始工作，或创建新项目': 'Pick a project to start working, or create a new one',
  '新建项目': 'New project',
  '创建一个新的压裂项目': 'Create a new fracturing project',
  '暂无项目，点击上方创建': 'No projects yet. Create one above.',
  '目标层: {v}': 'Target: {v}',
  '总深: {v}m': 'TD: {v} m',
  '项目创建成功': 'Project created',
  '创建失败': 'Creation failed',
  '创建': 'Create',
  '井名': 'Well name',
  '请输入井名': 'Enter a well name',
  '例如：FY-H1': 'e.g. FY-H1',
  '项目名': 'Project name',
  '请输入项目名': 'Enter a project name',
  '例如：龙马溪页岩气压裂项目': 'e.g. Longmaxi shale gas frac project',
  '油田': 'Field',
  '请输入油田名': 'Enter a field name',
  '例如：涪陵气田': 'e.g. Fuling gas field',
  '井型': 'Well type',
  '请选择井型': 'Select a well type',
  '目标层位': 'Target formation',
  '例如：龙马溪组下段': 'e.g. Lower Longmaxi',
  '总井深 (m)': 'Total depth (m)',
  '例如：4280': 'e.g. 4280',
  '备注': 'Notes',
  '项目描述（选填）': 'Project description (optional)',

  // ── 仪表盘 ──
  '← 切换项目': '← Switch project',
  '项目设置': 'Project settings',
  '总井深': 'Total depth',
  '项目成员': 'Members',
  '人': '',
  '功能模块': 'Modules',
  '单井测井': 'Well logs',
  '地层绘制': 'Formation mapping',
  '工况预警': 'Operation alerts',
  '岩石力学': 'Rock mechanics',
  '3D模型': '3D model',
  '统一导入、单位标准化、曲线审核与应用': 'Unified import, unit standardization, curve review and publishing',
  '数据中心应用后的标准测井曲线': 'Standardized well logs published from the Data Hub',
  '地层结构建模与可视化': 'Formation structure modeling and visualization',
  '储层甜点识别与评级': 'Reservoir sweet spot identification and grading',
  '压裂方案设计与段簇优化': 'Frac design and stage/cluster optimization',
  'PKN缝网扩展模拟': 'PKN fracture network propagation',
  '实时监测与预警': 'Real-time monitoring and alerts',
  '投资效益评估': 'Investment return evaluation',
  '力学参数剖面': 'Mechanical property profiles',
  '三维地质模型': '3D geological model',
  '实时监测面板': 'Live panels',
  '地层剖面 + 井眼轨迹': 'Formation section + well trajectory',
  '点击进入地层可视化': 'Open formation visualization',
  '查看 {well} 地层模型与井眼轨迹动画': 'View the {well} formation model and trajectory animation',
  '甜点评价 · 可压性分级': 'Sweet spots · fracability grading',
  '点击进入甜点评价': 'Open sweet spot evaluation',
  '测井曲线 · 地质/工程/综合甜点 · Ⅰ-Ⅳ 可压性分级':
    'Well logs · geological / engineering / combined sweet spots · Class I–IV fracability',

  // ── 爱压 AI ──
  // 「爱压」是产品定名 (见 AIPanel 注释), 英文界面保留原名, 只翻译说明文字
  '爱压 AI · 压裂设计智能顾问（可拖动）': '爱压 AI · fracture design advisor (draggable)',
  '压裂设计智能顾问': 'Fracture design advisor',
  '全局可用 · 基于当前项目数据': 'Available everywhere · grounded in current project data',
  ' · 未配置': ' · not configured',
  '开始新对话': 'Start a new conversation',
  '＋ 新对话': '＋ New chat',
  '查看历史对话': 'View chat history',
  '历史': 'History',
  '本次提问会用到的项目数据': 'Project data used for this question',
  '⚠ 当前项目尚无入库数据': '⚠ This project has no ingested data yet',
  '项目 #{id} 的历史对话': 'Chat history for project #{id}',
  '未选项目时的历史对话': 'Chat history without a project',
  ' · 仅自己可见': ' · visible only to you',
  '历史对话加载失败,请稍后重试。': 'Failed to load chat history. Please try again later.',
  '还没有历史对话。提问并收到回复后会自动保存。': 'No chat history yet. Conversations are saved after the first reply.',
  '该对话无法打开,可能已被删除。': 'This conversation could not be opened. It may have been deleted.',
  '删除这段对话?删除后无法恢复。': 'Delete this conversation? This cannot be undone.',
  '删除失败,请稍后重试。': 'Delete failed. Please try again later.',
  '重命名失败,请稍后重试。': 'Rename failed. Please try again later.',
  '重命名': 'Rename',
  '未命名对话': 'Untitled conversation',
  '{page} · {n} 条 · {time}': '{page} · {n} messages · {time}',
  ' · 当前': ' · current',
  '其他页面': 'Other page',
  '思考中…': 'Thinking…',
  '(无回复)': '(no reply)',
  '调用失败': 'Request failed',
  '上传失败': 'Upload failed',
  '没能读出文字': 'no text could be extracted',
  '当前连接的后端缺少此接口，或所选方案已删除。请核对后端部署版本和方案，刷新页面后重试。':
    'The connected backend does not provide this endpoint, or the selected design was deleted. Check the backend version and design, then refresh and retry.',
  '已读取《{name}》,共 {n} 字,提问时会作为参考资料一并发给模型。':
    'Read "{name}" ({n} characters). It will be sent to the model as reference material with your questions.',
  '《{name}》已保存,但{reason}。它不会被发给模型。':
    '"{name}" was saved, but {reason}. It will not be sent to the model.',
  '📎 参考文档': '📎 Reference documents',
  ' · 已选 {n} 份': ' · {n} selected',
  ' · {n} 份未选': ' · {n} not selected',
  '读取中…': 'Reading…',
  '＋ 上传文档(PDF / Word / Excel / 文本 / 图片,不限格式)': '＋ Upload a document (PDF / Word / Excel / text / image, any format)',
  '请先选择项目': 'Select a project first',
  '这里的文件': 'Files here are ',
  '不进数据中心、不参与计算': 'not added to the Data Hub and not used in calculations',
  ',只作为背景资料读给模型。': '; they are only read to the model as background.',
  '图片与扫描件会自动转写成文字(转写结果可能与原件有出入,请核对)。':
    'Images and scans are transcribed automatically (transcriptions may differ from the original; please check).',
  '{n} 字': '{n} chars',
  ' · {n} 页': ' · {n} pages',
  '问任何压裂相关的问题…(Enter 发送 · Shift+Enter 换行)': 'Ask anything about fracturing… (Enter to send · Shift+Enter for a new line)',
  '项目 #{id} 上下文已注入': 'Project #{id} context attached',
  '未选项目': 'No project selected',
  ' · 附 {n} 份文档': ' · {n} documents attached',
  '发送': 'Send',
  // 数据状态条: 文案来自后端 /ai/context-status/, 固定字符串, 在前端翻译
  '地层分层': 'Formation layers',
  '井轨迹': 'Survey',
  '压裂方案': 'Frac designs',
  '参考文档': 'Reference docs',
  '层': ' layers',
  '测点': ' stations',
  '深度点': ' depth pts',
  '段': ' intervals',
  '个': '',
  '份': '',
  '当前项目还没有任何已入库数据。爱压 AI 只能给通用方法，不会针对本井给出段数、液量、砂量等具体数值。':
    'This project has no ingested data yet. 爱压 AI can only give general methods and will not give well-specific stage counts, fluid or proppant volumes.',
  '尚未选择项目。': 'No project selected.',

  // 爱压 AI 快捷提问
  '解释整井完井与射孔设计': 'Explain the full-well completion and perforation design',
  '哪些压裂段需要人工复核?': 'Which stages need manual review?',
  '第1段为什么这样设计?': 'Why is stage 1 designed this way?',
  '射孔簇数如何沿用分段分簇方案?': 'How are cluster counts carried over from the staging plan?',
  '解释当前智能设计方案': 'Explain the current smart design',
  '类比案例为什么适合当前井?': 'Why do the analog cases fit this well?',
  '当前方案有哪些风险需要复核?': 'What risks in this design need review?',
  '解释当前泵注程序设计': 'Explain the current pump schedule',
  '液量和砂量是否匹配?': 'Do fluid and proppant volumes match?',
  '第1段泵注程序有什么风险?': 'What are the risks in the stage 1 pump schedule?',
  '哪些参数需要施工前确认?': 'Which parameters must be confirmed before the job?',
  '帮我看这套地层的可压性': 'Assess the fracability of this formation',
  '目标层定哪一层比较合理?': 'Which layer is the most reasonable target?',
  '相邻层应力差够不够形成阻挡层?': 'Is the stress contrast with adjacent layers enough to act as a barrier?',
  '这套地层最适合的射孔位置': 'Best perforation positions in this formation',
  '甜点分级的依据是什么?': 'What is the basis for sweet spot grading?',
  '哪些段适合优先压裂?': 'Which intervals should be fractured first?',
  'I/II 类段的设计差异': 'Design differences between Class I and II intervals',
  '可压性偏低怎么补救?': 'How to compensate for low fracability?',
  '评价当前方案合理性': 'Evaluate whether the current design is reasonable',
  '段距和簇数有没有优化空间?': 'Can stage spacing and cluster count be optimized?',
  '排查砂堵 / 早期脱砂风险': 'Check screen-out / early sand-off risk',
  '泵注程序怎么改善缝长?': 'How can the pump schedule improve fracture length?',
  '模拟出的缝长偏短怎么调整?': 'The simulated fracture is too short. What should I adjust?',
  '液效低怎么办?': 'What to do about low fluid efficiency?',
  '缝高是否被层应力有效阻挡?': 'Is fracture height effectively contained by layer stress?',
  '导流能力够不够支撑产能?': 'Is conductivity sufficient to support production?',
  '这口井适合做几段?': 'How many stages suit this well?',
  '推荐段长和簇数': 'Recommended stage length and cluster count',
  '滑溜水+线性胶组合的适用条件': 'When to combine slickwater with linear gel',
  '页岩气和致密油的设计差异': 'Design differences between shale gas and tight oil',

  // ── 爱压 AI 操作模式 ──
  '问答': 'Ask',
  '操作': 'Act',
  '操作模式: 驱动左侧页面执行, 改动前逐步确认': 'Action mode: drives the page on the left; changes need your confirmation',
  '输入 / 使用命令模板': 'Type / for command templates',
  '描述要做的操作, 例如: 帮我生成泵注程序然后跑模拟 (或输入 / 命令)':
    'Describe what to do, e.g. "generate the pump schedule then run the simulation" (or type a / command)',
  '执行失败': 'Failed',
  '按命令模板执行:': 'Running command template:',
  '可用命令模板:': 'Available command templates:',
  '(已忽略无法识别的命令: {list})': '(ignored unknown commands: {list})',
  '也可以直接用命令模板, 输入 /帮助 查看。': 'You can also use command templates; type /help to list them.',
  '待执行': 'Pending',
  '待确认': 'Needs confirmation',
  '执行中': 'Running',
  '完成': 'Done',
  '失败': 'Failed',
  '已跳过': 'Skipped',
  '方案 #{id}': 'design #{id}',
  '第 {list} 段': 'stages {list}',
  '全部段': 'all stages',
  '命令模板 · 操作计划': 'Command template · action plan',
  '爱压 AI · 操作计划': '爱压 AI · action plan',
  '停止': 'Stop',
  '已停止': 'Stopped',
  '确认运行': 'Run',
  '确认执行': 'Confirm',
  '跳过': 'Skip',
  '将启动求解器, 可在页面上随时取消': 'Starts the solver; you can cancel it on the page at any time',
  '会修改方案或打开确认对话框': 'Changes the design or opens a confirmation dialog',
  '未知命令 {cmd}': 'Unknown command {cmd}',
  '已打开「{page}」': 'Opened "{page}"',
  '当前页面没有可读取的状态': 'This page exposes no status',
  '「{page}」页面未就绪, 请确认已选择项目后重试': 'The "{page}" page is not ready. Make sure a project is selected and retry.',
  '页面已离开, 命令未执行': 'The page was closed; the command did not run',
  '已执行': 'Done',
  // 命令标题
  '打开页面': 'Open page',
  '读取当前页面状态': 'Read page status',
  '列出压裂方案': 'List frac designs',
  'AI 生成压裂方案': 'AI-generate a frac design',
  '激活压裂方案': 'Activate frac design',
  '智能分段': 'Smart staging',
  '保存分段分簇方案': 'Save staging & clusters',
  '完井与射孔智能设计': 'Smart completion & perforation design',
  '保存完井与射孔方案': 'Save completion & perforation',
  '保存材料设计': 'Save materials',
  '智能生成泵注程序': 'Generate pump schedule',
  '保存泵注程序': 'Save pump schedule',
  '切换模拟方案': 'Switch simulation design',
  '选择模拟压裂段': 'Select stages to simulate',
  '运行压裂模拟': 'Run fracture simulation',
  // 命令模板说明与报错
  '打开页面 (页面名见侧边栏)': 'Open a page (names as in the sidebar)',
  '列出项目的压裂方案': "List the project's frac designs",
  '打开 AI 生成方案对话框': 'Open the AI design dialog',
  '设为当前方案': 'Make it the current design',
  '打开智能分段对话框': 'Open the smart staging dialog',
  '用当前方案运行模拟, 不写段号=全部段': 'Simulate the current design; no stage list = all stages',
  '切换方案并自动计算全部段': 'Switch design and simulate all stages',
  '{cmd} 不需要参数': '{cmd} takes no arguments',
  '找不到页面「{page}」': 'Page "{page}" not found',
  '请写方案编号, 例如 /激活方案 12': 'Give a design number, e.g. /activate 12',
  '切换方案会自动计算全部段: 请先 /模拟 方案 {id}, 再用 /模拟 段 … 计算指定段':
    'Switching design simulates all stages: run /simulate design {id} first, then /simulate stages … for specific stages',
  '无法识别「{text}」, 格式: /模拟 方案 12 段 1,2,3': 'Cannot parse "{text}". Format: /simulate stages 1,2,3',
  '段号无效, 例如 段 1,2,3': 'Invalid stage list, e.g. stages 1,2,3',
  '未知命令 {cmd}, 输入 /帮助 查看可用命令': 'Unknown command {cmd}. Type /help for the list.',

  // ── 成像测井解释 ──
  '成像测井解释': 'Image log interpretation',
  '上传成像测井 PDF 或图片, 自动拾取裂缝正弦与井壁崩落; 结果为候选, 人工确认后才发布到天然裂缝表':
    'Upload a borehole image log (PDF or image) to pick fracture sinusoids and breakouts automatically. Picks are candidates and are published to natural fractures only after review.',
  '读取识别记录失败': 'Failed to load the interpretation',
  '请填写图像顶深和底深, 底深须大于顶深': 'Enter the image top and bottom depth; bottom must be greater than top',
  '请先选择成像测井 PDF 或图片': 'Choose an image log PDF or image first',
  '识别完成: {n} 条裂缝候选, {m} 段崩落/诱导缝': 'Done: {n} fracture candidates, {m} breakout / induced-fracture intervals',
  '识别失败': 'Recognition failed',
  '已按新参数重新识别': 'Re-run with the new parameters',
  '保存复核结果失败': 'Failed to save the review',
  '已发布 {n} 条裂缝到「天然裂缝 · 裂缝参数」': 'Published {n} fractures to Natural fractures · Fracture parameters',
  '发布失败': 'Publish failed',
  '删除失败': 'Delete failed',
  '深度 (m)': 'Depth (m)',
  '倾角': 'Dip',
  '倾向': 'Dip az.',
  '覆盖': 'Cover',
  '类型': 'Type',
  '复核': 'Review',
  '确认': 'Accept',
  '否决': 'Reject',
  '崩落': 'Breakout',
  '诱导缝': 'Induced',
  '井段 (m)': 'Interval (m)',
  '方位': 'Az.',
  '宽度': 'Width',
  '点击或拖入成像测井 PDF / 图片': 'Click or drop an image log PDF / image',
  '图像需为 0–360° 展开图, 左边缘为起始方位': 'Unrolled 0–360° image; the left edge is the start azimuth',
  '深度与井眼': 'Depth & borehole',
  '顶深 (m)': 'Top (m)',
  '底深 (m)': 'Bottom (m)',
  '井径 (mm)': 'Hole size (mm)',
  '起始方位 (°)': 'Start azimuth (°)',
  'PDF 页码': 'PDF page',
  '图像区域 (去掉表头/刻度道)': 'Image area (exclude headers / scale tracks)',
  '左边界 %': 'Left %',
  '右边界 %': 'Right %',
  '上边界 %': 'Top %',
  '下边界 %': 'Bottom %',
  '识别参数': 'Recognition',
  '特征颜色': 'Feature colour',
  '暗色 (电成像)': 'Dark (resistivity)',
  '亮色': 'Bright',
  '最大倾角 (°)': 'Max dip (°)',
  '最小方位覆盖率': 'Min azimuth coverage',
  '上传并识别': 'Upload & analyze',
  '按当前参数重新识别': 'Re-run with these parameters',
  '重新识别会清空当前的人工复核状态': 'Re-running clears the current review',
  '识别记录': 'Interpretations',
  '暂无记录': 'None yet',
  '{n} 条裂缝 · {m} 段崩落': '{n} fractures · {m} breakouts',
  '已发布': 'Published',
  '删除这条识别记录?': 'Delete this interpretation?',
  '原图': 'Original',
  '增强': 'Enhanced',
  '二值化': 'Binary',
  '边缘': 'Edges',
  '候选': 'Candidate',
  '已确认': 'Accepted',
  '已否决': 'Rejected',
  '上传成像测井后在这里显示识别结果': 'Results appear here after you upload an image log',
  '暂无识别结果': 'No results yet',
  '裂缝候选': 'Candidates',
  '崩落段长 (m)': 'Breakout length (m)',
  '崩落段': 'Breakouts',
  '诱导缝段': 'Induced',
  'SHmax 方位': 'SHmax azimuth',
  '裂缝拾取': 'Fracture picks',
  '候选全部确认': 'Accept all candidates',
  '重置': 'Reset',
  '没有识别到裂缝, 可降低最小方位覆盖率或调整图像区域': 'No fractures found. Try a lower coverage threshold or adjust the image area.',
  '井壁崩落 / 钻井诱导缝': 'Breakouts / drilling-induced fractures',
  '未识别到成对的崩落或诱导缝': 'No paired breakouts or induced fractures found',
  '崩落沿最小水平主应力方向展布, 诱导缝沿最大水平主应力方向; SHmax 可用于校核地应力方向与坍塌压力模型。':
    'Breakouts align with Shmin and induced fractures with SHmax; use SHmax to check stress orientation and the collapse-pressure model.',
  '发布已确认裂缝到天然裂缝表 ({n} 条)': 'Publish accepted fractures to natural fractures ({n})',
  '上次发布 {n} 条; 再次发布会替换上一次的结果': 'Last published {n}; publishing again replaces them',
  '只发布已确认的裂缝, 来源记为「成像测井」': 'Only accepted fractures are published, with source "image log"',
  '识别成像测井': 'Analyze image log',
  '发布成像测井裂缝': 'Publish image-log fractures',
  '张开缝': 'Open',
  '充填缝': 'Filled',
  '闭合缝': 'Healed',
  '层理缝': 'Bedding',

  // ── 物模实验库 ──
  '物模实验库': 'Lab experiments',
  '物模实验对标': 'Lab experiment matching',
  '物理模拟实验数据统一入库, 与当前井条件对标, 为压裂设计提供实验依据; 实验库全公司共享':
    'Physical simulation lab data in one place, matched against the current well to support frac design. Shared company-wide.',
  '读取实验库字段失败': 'Failed to load the experiment schema',
  '读取实验数据失败': 'Failed to load experiments',
  '模板下载失败': 'Template download failed',
  '导入失败': 'Import failed',
  '当前项目没有可用于这类实验的力学/压力数据, 请手动填写': 'This project has no stress/pressure data for this experiment type. Enter values manually.',
  '已带入 {n} 项井条件 (来自 {m} 个力学数据点)': 'Filled {n} well conditions (from {m} mechanics points)',
  '读取项目数据失败': 'Failed to read project data',
  '对标分析失败': 'Matching failed',
  '相似度': 'similarity',
  '请解读以下物模实验对标结果, 说明对当前井压裂设计的指导意义, 并指出室内与现场的尺度差异和需要复核的地方。':
    'Interpret the following lab experiment matching results: explain what they mean for this well\'s frac design, and point out lab-to-field scale differences and what needs checking.',
  '实验类型': 'Experiment type',
  '目标条件': 'Target conditions',
  '相似实验': 'Similar experiments',
  '无': 'none',
  '实验编号': 'Experiment ID',
  '层位': 'Formation',
  '岩性': 'Lithology',
  '实验室': 'Lab',
  '删除这条实验?': 'Delete this experiment?',
  '按编号、层位、岩性、实验室搜索': 'Search by ID, formation, lithology or lab',
  '下载导入模板': 'Download template',
  '只有工程师或管理员可以导入': 'Only engineers and admins can import',
  '导入实验数据': 'Import experiments',
  '共 {n} 条': '{n} total',
  '还没有这一类实验数据, 下载模板整理后导入': 'No experiments of this type yet. Download the template, fill it in and import.',
  '对标当前井 · 设计参考': 'Match current well · design reference',
  '填写目标条件, 找出条件最接近的实验并总结规律': 'Enter target conditions to find the closest experiments and summarize trends',
  '顶深': 'Top',
  '底深': 'Bottom',
  '从项目数据带入': 'Fill from project data',
  '层位 (同层位优先)': 'Formation (same formation preferred)',
  '对标分析': 'Match',
  '设计参考': 'Design reference',
  '目标闭合应力下的导流能力排序': 'Conductivity ranking at target closure stress',
  '支撑剂': 'Proppant',
  '外推': 'extrapolated',
  '导出导流能力表 (压裂模拟格式)': 'Export conductivity tables (simulation format)',
  '没有符合条件的实验': 'No matching experiments',
  '让爱压解读': 'Ask 爱压 AI to interpret',
  '导入结果': 'Import result',
  '知道了': 'OK',
  '新增 {a} 条, 更新 {b} 条, 跳过 {c} 行。': '{a} added, {b} updated, {c} rows skipped.',
  '未识别的列 (已忽略)': 'Unrecognized columns (ignored)',
  '第 {row} 行': 'Row {row}',
  '真三轴水力压裂物模': 'True-triaxial hydraulic fracturing',
  '大尺寸岩样真三轴加载下的水力压裂实验: 应力差、排量、黏度对起裂与缝网复杂度的影响。':
    'Large-block true-triaxial fracturing tests: effect of stress contrast, rate and viscosity on initiation and network complexity.',
  '支撑剂导流能力': 'Proppant conductivity',
  '不同闭合应力、铺砂浓度下的导流能力测试 (API RP 19D 一类)。': 'Conductivity at different closure stresses and loadings (API RP 19D style).',
  '支撑剂输送/沉降': 'Proppant transport / settling',
  '可视化平板/裂缝模拟装置中的支撑剂输送与沉降实验。': 'Proppant transport and settling in slot / fracture flow cells.',
  '压裂液流变': 'Fluid rheology',
  '压裂液在温度、剪切下的黏度与流变参数、降阻率、破胶时间。': 'Fluid viscosity and rheology under temperature and shear, friction reduction and break time.',
  '岩石力学实验': 'Rock mechanics tests',
  '三轴/单轴压缩、巴西劈裂、断裂韧性等岩心实验, 用于标定测井解释的力学参数。':
    'Core tests (triaxial/UCS, Brazilian, toughness) used to calibrate log-derived mechanical properties.',
  '实验名称': 'Name',
  '实验日期': 'Date',
  '岩样/样品': 'Sample',
  '垂向应力': 'Vertical stress',
  '最大水平主应力': 'Max horizontal stress',
  '最小水平主应力': 'Min horizontal stress',
  '水平应力差': 'Horizontal stress contrast',
  '注入排量': 'Injection rate',
  '压裂液黏度': 'Fluid viscosity',
  '层理夹角': 'Bedding angle',
  '天然裂缝密度': 'Natural fracture density',
  '温度': 'Temperature',
  '试样尺寸': 'Sample size',
  '压裂液类型': 'Fluid type',
  '延伸压力': 'Propagation pressure',
  '缝网复杂度指数': 'Complexity index',
  '裂缝形态': 'Fracture morphology',
  '裂缝面积': 'Fracture area',
  '闭合应力': 'Closure stress',
  '支撑剂类型': 'Proppant type',
  '粒径目数': 'Mesh',
  '铺砂浓度': 'Loading',
  '测试流体': 'Test fluid',
  '导流能力': 'Conductivity',
  '渗透率': 'Permeability',
  '嵌入深度': 'Embedment',
  '破碎率': 'Crush',
  '支撑剂视密度': 'Apparent density',
  '携砂液黏度': 'Carrier viscosity',
  '排量': 'Rate',
  '缝宽': 'Slot width',
  '砂比': 'Sand ratio',
  '沉降速度': 'Settling velocity',
  '砂堤高度比': 'Bed height ratio',
  '输送距离': 'Transport distance',
  '液体体系': 'Fluid system',
  '剪切速率': 'Shear rate',
  '剪切时间': 'Shear time',
  '表观黏度': 'Apparent viscosity',
  '稠度系数 K': 'Consistency K',
  '流性指数 n': 'Flow index n',
  '降阻率': 'Friction reduction',
  '破胶时间': 'Break time',
  '取样深度': 'Sample depth',
  '围压': 'Confining pressure',
  '取心方向': 'Core orientation',
  '静态杨氏模量': "Static Young's modulus",
  '静态泊松比': "Static Poisson's ratio",
  '单轴抗压强度': 'UCS',
  '抗拉强度': 'Tensile strength',
  '内聚力': 'Cohesion',
  '内摩擦角': 'Friction angle',
  '断裂韧性': 'Fracture toughness',
};
